import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'dbs-confirm-dialog',
  templateUrl: './dbs-confirm-dialog.component.html',
  styleUrls: ['./dbs-confirm-dialog.component.scss'],
})
export class DbsConfirmDialogComponent {
  title = '';
  message = '';
  confirmButtonText = '';
  cancelButtonText = '';
  /**
   * 0: notification dialog
   * 1: confirm dialog
   */
  type = 0;
  messageLeft = false;
  useInnerHTML = false;
  isDisplayHeader = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    public dialogRef: MatDialogRef<DbsConfirmDialogComponent>,
  ) {
    if (this.data) {
      this.title = this.data.title;
      this.message = this.data.message;
      this.type = this.data.type || 0;
      if (this.type) {
        this.cancelButtonText = 'BUTTON.CANCEL';
        this.confirmButtonText = 'OK';
      } else {
        this.cancelButtonText = 'BUTTON.CLOSE';
        this.confirmButtonText = 'BUTTON.CLOSE';
      }
      if (this.data.cancelButtonText) {
        this.cancelButtonText = this.data.cancelButtonText;
      }
      if (this.data.confirmButtonText) {
        this.confirmButtonText = this.data.confirmButtonText;
      }
      this.messageLeft = this.data.messageLeft || false;
      this.useInnerHTML = this.data.useInnerHTML || false;
      this.isDisplayHeader = this.data.hasOwnProperty('isDisplayHeader') ? this.data.isDisplayHeader : false;
    }
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onDismiss(): void {
    this.dialogRef.close(false);
  }
}
